import queryString from 'query-string';

import { createGenericDispatcher } from '../../action/action-dispatcher-factory';
import {
  applicantAutomationsStateForJobIdSelector,
  applicantAutomationsStateForOrgIdSelector,
} from '../applicant-automation-selectors';

import * as Api from '../../api/api';

export const loadApplicantAutomations = ({ orgId, jobId }: { orgId: number; jobId?: number }) =>
  createGenericDispatcher({
    name: 'LOAD_APPLICANT_AUTOMATIONS',
    loadFunction: () =>
      Api.get(
        `/applicant-automations?${queryString.stringify({
          orgId,
          jobId,
        })}`,
      ),
    args: { orgId, jobId },
    shouldExecuteSelector: (state: any) =>
      jobId
        ? applicantAutomationsStateForJobIdSelector(state, jobId)
        : applicantAutomationsStateForOrgIdSelector(state, orgId),
  });
